import React, { createContext, useContext, useEffect, useState } from "react";

const Ctx = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(localStorage.getItem("el_theme") || "dark");
  useEffect(() => {
    localStorage.setItem("el_theme", theme);
    document.documentElement.dataset.theme = theme;
  }, [theme]);
  return (
    <Ctx.Provider value={{ theme, setTheme, toggle: () => setTheme((v) => (v === "dark" ? "light" : "dark")) }}>
      {children}
    </Ctx.Provider>
  );
};

export const useTheme = () => useContext(Ctx);
